import React, { Component, useState, useEffect, useRef } from 'react'
import { Card, CardActions, Typography, Button } from '@mui/material';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { MdDragIndicator } from 'react-icons/md';
import { LiaBookSolid } from "react-icons/lia";
import moment from 'moment';
import SFDotsPagination from '../components/SFDotsPagination';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import { isMobile } from 'react-device-detect';
import MomentTz from 'moment-timezone'
import { getDateFormat } from '../../../../common/functions';
import ApiRequestService from '../../../../components/ApiRequestService';

class DueAssignmentWidget extends Component {

    constructor(props) {
        super(props);

        this.state = {
            assignments: [],
            currentAssignment: null,
            loading: false,
            currentIndex: 0,
            timeZone: "",
        }
    }

    componentDidMount() {
        if (this.props.course && this.props.course.course_id) {
            this.getDueAssignment()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.course?.course_id !== this.props.course?.course_id) {
            if (this.props.course && this.props.course.course_id) {
                this.getDueAssignment()
            }
        }
        if (prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getDueAssignment();
        }
    }

    getDueAssignment = () => {
        this.setState({
            loading: true,
        })
        let response = ApiRequestService({
            method: "POST",
            url: "/getDueAssignment",
            data: {
                course_id: this.props.course.course_id,
                userName: this.props.selectedStudentUserName,
            }
        });

        response.then(res => {
            if (res && res.data && res.data.data) {
                let result = res.data.data;
                console.debug("result", result)
                this.setState({
                    timeZone: result.time_zone,
                })
                if (result.quiz_data) {
                    let quizDataArr = result.quiz_data;
                    this.setState({
                        assignments: quizDataArr,
                        currentAssignment: quizDataArr[0],
                    })
                } else {
                    this.setState({
                        assignments: [],
                        currentAssignment: null,
                    })
                }
            }

        }).catch(err => {
            console.debug("err", err)
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    handleTakeQuizURL = (assignment) => {

        console.debug("assignment?.courseName", assignment, this.props.course)

        // TODO: Probably will change the takequiz name
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quiz_type}&course_name=${this.props.course.course_name}`

        this.props.handleRoute(url)
    }

    handleChangeCurrentIndex = (index) => {
        this.setState({
            currentIndex: index,
            currentAssignment: this.state.assignments[index]
        })
    }

    getDate = (date, time) => {
        let dateTime = MomentTz.tz(date + " " + time, 'DD/MM/YYYY hh:mm:ss',
            this.state.timeZone).toDate();
        let dateTimeStr = `${dateTime.getMonth()}/${dateTime.getDate()}/${dateTime.getFullYear()}`
        return dateTimeStr;
    }

    render() {
        const { assignments, loading, currentAssignment, timeZone } = this.state;
        return (
            <Card className='h-100 w-100 position-relative'
                style={{ backgroundColor: '#9e9e9e', position: 'relative' }} sx={{ boxShadow: 3, borderRadius: 2 }}
            >
                <Card className='w-100 position-relative p-3' style={{ backgroundColor: '#fff', height: assignments && assignments.length > 0 ? '85%' : '100%' }} sx={{ boxShadow: 3, borderRadius: 2 }}>
                    <div className='d-flex justify-content-between align-items-end'>
                        {loading ? null :
                            <>
                                <Typography
                                    fontSize={isMobile ? 16 : 18}
                                    fontWeight={'500'} >
                                    {assignments.length === 0 ? <span style={{ visibility: "hidden" }}>You have no assignments</span> : (
                                        assignments.length > 1 ? <span>
                                            You have <strong style={{ color: "#bb0000" }}>{assignments.length}</strong> open assignments
                                        </span> : "You have an assignment due"
                                    )}
                                </Typography>
                                <div className='cursor-pointer drag-handle' style={{ cursor: 'move' }}>
                                    <MdDragIndicator fontSize={24} />
                                </div>
                            </>}
                    </div>
                    {loading ? (
                        <div className='h-100 mt-5 position-relative'>
                            <div className='w-100 position-relative'>
                                <Skeleton className='my-2' count={5} />
                            </div>
                        </div>
                    ) :
                        (isMobile ? <div className='w-100 overflow-auto p-0 m-0'>
                            <SwipeableAssignments
                                courseName={this.props.course?.course_name}
                                assignments={assignments}
                                handleChangeCurrentIndex={this.handleChangeCurrentIndex}
                                currentIndex={this.state.currentIndex}
                            />
                        </div> :
                            (currentAssignment && timeZone ? (
                                <div style={{
                                    flex: "0 0 100%",
                                }}>
                                    <div className='mt-3 fontClass-16 font-weight-bold'>
                                        {currentAssignment?.quiz_name}
                                        <div className='fontClass-12 text-secondary font-weight-light'>
                                            {currentAssignment ? (currentAssignment.is_nongraded ? "(Nongraded Assignment)" : "(Graded Assignment)") : ''}
                                        </div>
                                    </div>
                                    {/* <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                        COURSE
                                    </Typography>
                                    <div className='fontClass-14'>
                                        {this.props.course?.course_name}
                                    </div> */}

                                    <div className='d-flex justify-content-start mt-2' style={{
                                        gap: '1rem'
                                    }}>
                                        <div>
                                            <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                                TYPE
                                            </Typography>
                                            <div className='fontClass-14'>
                                                {currentAssignment?.quiz_type === 0 ? "Mastery" : "Test"}
                                            </div>
                                        </div>
                                        <div>
                                            <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                                OPEN
                                            </Typography>
                                            <div className='fontClass-14'>
                                                {getDateFormat(currentAssignment?.start_date, timeZone)}
                                            </div>
                                        </div>
                                        <div>
                                            <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                                CLOSE
                                            </Typography>
                                            <div className='fontClass-14'>
                                                {getDateFormat(currentAssignment?.end_date, timeZone)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-between align-items-start mt-2' style={{ gap: '8px' }}>
                                        <div className=''>
                                            <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                                CATEGORIES ({currentAssignment?.quiz_details?.length})
                                            </Typography>
                                            {
                                                <div className='fontClass-14 mt-1'>
                                                    <ul className='pl-4' style={{
                                                        height: isMobile ? '100px' : '120px',
                                                        overflowY: 'auto'
                                                    }}>
                                                        {currentAssignment?.quiz_details?.map((category, cindex) => {
                                                            return <li key={cindex}>{category.category_name}</li>
                                                        })}
                                                    </ul>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            ) : null)
                        )

                    }
                    {assignments && assignments.length === 0 &&
                        <div className='w-100 h-100 position-relative'>
                            <div className='w-100  d-flex flex-column justify-content-center align-items-center position-relative text-center'
                                style={{
                                    height: "calc(100% - 110px)"
                                }}
                            >
                                <LiaBookSolid fontSize={96} color='#666' />
                                <Typography color='primary' fontWeight={'500'} variant='h5'>
                                    No open/current assignments
                                </Typography>
                                {/* <br />
                                <em>This card displays only the assignments that are <strong>DUE</strong> this week.</em>
                                <br /><br />
                                <em>There could be assignments that are open but not due this week.</em>
                                <br /><br />
                                <center>
                                    <em>
                                    So please see <strong>"List of all assignments"</strong>.
                                    </em>
                                </center> */}
                                <Typography className='mt-2 d-none'>
                                    <em>You could create practice assignments to improve your accuracy and time.</em>
                                </Typography>
                            </div>
                        </div>
                    }
                    {assignments && assignments.length > 1 && currentAssignment &&
                        <CardActions className='d-flex justify-content-end'>
                            <Button variant='contained' color='primary' className='mt-1'
                                onClick={() => {
                                    this.handleTakeQuizURL(currentAssignment)
                                }}>Go to Assignment</Button>
                        </CardActions>}
                </Card>

                {!loading && assignments && assignments.length === 1 && currentAssignment &&
                    <CardActions className='d-flex justify-content-end'>
                        <Button variant='contained' color='primary' className='sf-white-btn mt-1' onClick={() => {
                            this.handleTakeQuizURL(currentAssignment)
                        }}>Go to Assignment</Button>
                    </CardActions>
                }

                <div className='justify-content-center align-items-center position-absolute w-100' style={{
                    bottom: '1.4rem',
                    display: !loading && assignments.length > 1 ? 'flex' : 'none'
                }}>
                    <SFDotsPagination
                        handleDotClick={(index) => {
                            this.setState({
                                currentIndex: index,
                                currentAssignment: assignments[index],
                            })
                        }}
                        isMobile={isMobile}
                        currentIndex={this.state.currentIndex}
                        total={assignments ? assignments.length : 0}
                    />
                </div>

            </Card>
        )
    }
}

const SwipeableAssignments = ({ courseName, assignments, handleChangeCurrentIndex, currentIndex }) => {

    const swiperRef = useRef();

    useEffect(() => {
        console.debug("swiperRef", swiperRef, currentIndex);
        if (swiperRef.current && swiperRef.current.state && swiperRef.current.state.swiper) {
            let swiper = swiperRef.current.state.swiper;
            if (swiper && swiper.slideTo) {
                swiper.slideTo(currentIndex);
            }
        }
    }, [currentIndex])

    return (
        <Swiper
            ref={swiperRef}
            swiperOptions={{
                slidesPerView: 1
            }}
            initialSlide={currentIndex}
            navigation={false}
            pagination={false}
        >
            {assignments.map((currentAssignment, index) => {
                return (
                    <Slide
                        key={index}
                        onActive={() => {
                            handleChangeCurrentIndex(index);
                        }}
                    >
                        <div style={{
                            flex: "0 0 100%",
                        }}>
                            <div className='mt-3 fontClass-16 font-weight-bold'>
                                {currentAssignment?.quiz_name}
                                <div className='fontClass-12 text-secondary font-weight-light'>
                                    {currentAssignment ? (currentAssignment.is_nongraded ? "(Nongraded Assignment)" : "(Graded Assignment)") : ''}
                                </div>
                            </div>
                            {/* <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                COURSE
                            </Typography>
                            <div className='fontClass-14'>
                                {courseName}
                            </div> */}
                            <div className='d-flex justify-content-start mt-2' style={{
                                gap: '1rem'
                            }}>
                                <div>
                                    <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                        TYPE
                                    </Typography>
                                    <div className='fontClass-14'>
                                        {currentAssignment?.quiz_type === 0 ? "Mastery" : "Test"}
                                    </div>
                                </div>
                                <div>
                                    <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                        OPEN
                                    </Typography>
                                    <div className='fontClass-14'>
                                        {currentAssignment && currentAssignment?.start_date ? moment(currentAssignment?.start_date, 'DD/MM/YYYY').format('MM/DD/YYYY') : ''}
                                    </div>
                                </div>
                                <div>
                                    <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                        CLOSE
                                    </Typography>
                                    <div className='fontClass-14'>
                                        {currentAssignment && currentAssignment?.end_date ? moment(currentAssignment?.end_date, 'DD/MM/YYYY').format('MM/DD/YYYY') : ''}
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-start mt-2' style={{ gap: '8px' }}>
                                <div className=''>
                                    <Typography color={'primary'} fontWeight={'500'} className='mt-2'>
                                        CATEGORIES ({currentAssignment?.quiz_details?.length})
                                    </Typography>
                                    {
                                        <div className='fontClass-14 mt-1'>
                                            <ul className='pl-4' style={{
                                                height: '120px',
                                                overflowY: 'auto'
                                            }}>
                                                {currentAssignment?.quiz_details?.map((category, cindex) => {
                                                    return <li key={cindex}>{category.category_name}</li>
                                                })}
                                            </ul>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </Slide>
                )
            })}

        </Swiper>
    )
}

export default DueAssignmentWidget;
